export default "__VITE_ASSET__B1g8S$TK__"